import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { FaFacebook, FaInstagram, FaTiktok, FaTwitter, FaYoutube } from "react-icons/fa";
import { IconEmail } from '../../../assets';
import { isColorLight, removerAcentos } from '../../../utils/FunctionsGlobals';
import { ehAtalhoDeRodape } from '../../../utils/footerShortcuts';
import { trackMetaEvent } from '../../../utils/metaPixel';
import { escondeLogoDoTopoNaHome } from '../../../utils/logoNoHero';
import { useAuth, useSiteRegiao } from '../../context/Info';
import SeletorIdiomas, { temSeletorIdiomas } from '../idiomas/SeletorIdiomas';
import SeletorMoeda from '../idiomas/SeletorMoeda';
import { temSeletorMoedaManual } from '../../../utils/idiomaMoedaSite';
import styles from './Topo.module.css';

// Tenants que pediram o topo SEM a busca (código + OK + BUSCA AVANÇADA). Gate por codsite
// de propósito: nenhum outro site com modelo_topo=3 perde a busca do cabeçalho.
const TOPO_SEM_BUSCA_CODSITES = new Set([2619, 2504]);

const Topo2: React.FC<{
    site: any;
    setActiveDrawer: any;
    setBuscaAvancada: any;
}> = ({ site: siteProp, setActiveDrawer,setBuscaAvancada }) => {
    // MULTI-REGIÃO: contatos (tel1/tel2/email1) trocados pelos da região ativa quando houver
    const site = useSiteRegiao(siteProp);

    const {
        allDataHome
    } = useAuth();
    const router = useRouter();
    const { codsite } = router.query;
    const logoHeight = Number(site?.id) === 2539 ? 250 : site?.tamanho_logo;
    const currentPath = router.asPath.split('?')[0].split('#')[0];
    const shouldHideSite1630Socials = Number(site?.id) === 1630 && currentPath !== '/';
    const [scrolled, setScrolled] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const cor_font_2 = isColorLight(site?.cor2) ? site?.cor11 : site?.cor13;
    const withCodsite = (href: string) => {
        if (!href || !href.startsWith('/') || !codsite) return href;
        const codsiteValue = Array.isArray(codsite) ? codsite[0] : codsite;
        const [base, hash = ''] = href.split('#');
        const [pathname, query = ''] = base.split('?');
        const params = new URLSearchParams(query);
        params.set('codsite', String(codsiteValue));
        const queryString = params.toString();
        const nextHref = queryString ? `${pathname}?${queryString}` : pathname;
        return hash ? `${nextHref}#${hash}` : nextHref;
    };

    /* monta listener só 1 vez */
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 50);
        onScroll();
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleSearch = () => {
        if (searchTerm.trim()) {
            router.push(withCodsite(`/imoveis/venda/-/-/-/-/${encodeURIComponent(searchTerm)}`));
        }
    };

    const handleAdvancedSearch = () => {
        trackMetaEvent(site, 'ViewContent', { content_name: 'Busca avançada', content_category: 'property_search' });
        if(site?.id == 2379)
            if(setBuscaAvancada)
                setBuscaAvancada(true)
            else
                router.push(withCodsite(`/imoveis/venda/-/-/-/-`));
        else
            router.push(withCodsite('/#myLink'));
    };

    const hexToRgb = (hex: string) => {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    };

    const getBackgroundColor = () => {
        if (scrolled && site?.cor1) {
            const rgb = hexToRgb(site.cor1);
            return rgb ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.9)` : site.cor1;
        }
        return 'transparent';
    };

    const getFontColor = () => {
        if (scrolled && site?.cor1) {
            const corletra = isColorLight(site?.cor1) ? site?.cor11 : site?.cor13
            return corletra;
        }
        return 'white';
    };

    const allSocials = [
        {
            href: site?.Dados?.instagram || '',
            id: 3,
            icon: <FaInstagram style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Instagram'
        },
        {
            href: site?.Dados?.facebook || '',
            id: 1,
            icon: <FaFacebook style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Facebook'
        },
        {
            href: site?.Dados?.twitter || '',
            id: 4,
            icon: <FaTwitter style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Twitter'
        },
        {
            href: site?.Dados?.tiktok || '',
            id: 5,
            icon: <FaTiktok style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Tiktok'
        },
        {
            href: site?.Dados?.youtube || '',
            id: 2,
            icon: <FaYoutube style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Youtube'
        },
    ];
    const openDrawer = () => {
        setActiveDrawer(true);
    };
    const trackLeadLazy = () => {
        void import('../../whatsAppButton/WhatsAppButton')
            .then(({ trackLead }) => {
                trackLead(site, null);
            })
            .catch(() => undefined);
    };

    // ehAtalhoDeRodape: nos tenants do gate (cs2619), as páginas institucionais
    // (Trabalhe conosco / Política de privacidade / Quem somos) DESCEM pro rodapé em
    // ícone — então não podem seguir no menu. Fora do gate, a função devolve false.
    // cs2619 (01/09): o cliente pediu o TOPO limpo — o atalho "Anuncie seu imóvel" some
    // DAQUI apenas; a página segue no menu lateral (drawer) e no rodapé, como sempre.
    // Gate por tenant de propósito: nenhum outro site perde item de menu no topo.
    const ehMenuOcultoNoTopo = (menu: any): boolean => {
        if (Number(site?.id) !== 2619) return false;
        const titulo = removerAcentos(String(menu?.titulo ?? '')).toLowerCase().replace(/\s+/g, ' ').trim();
        return titulo === 'anuncie seu imovel';
    };

    const menusElegiveis = (allDataHome?.menus ?? []).filter((v: any) =>
        v?.Disponivel && (v?.link || (!v?.link && v?.titulo !== "Equipe")) && !ehAtalhoDeRodape(site, v)
            && !ehMenuOcultoNoTopo(v)
    )
    .slice(0, 3);

    return (
        // BUILDER: âncora estável do bloco "topo" (variante modelo_topo=3) — mesma
        // chave do Topo padrão, usada em toda página que renderiza este cabeçalho.
        <nav className={site?.id == 2379 ? styles.nav1 : styles.nav} data-builder-section="topo" style={{
            position: 'fixed',
            top: 0,
            width: '100%',
            zIndex: 99,
            background: getBackgroundColor(),
            transition: 'background 0.3s ease'
        }}>
            <div className={`${styles.navContainer} ${site?.id == 2080 ? styles.navContainerLogoCenter2080 : ''}`} style={site?.id == 2379 ? {margin: '0 5%',width: '90%'} : {}}>
                {/* Logo */}
                {escondeLogoDoTopoNaHome(site, currentPath) ? (
                    // cs2580 (utils/logoNoHero): na home a logo fica grande no hero; aqui só o espaço dela, para o menu não andar
                    <div className={styles.navLogoContainer} aria-hidden="true" />
                ) : (
                <Link prefetch={false} href={withCodsite("/")} onClick={() => trackMetaEvent(site, 'ViewContent', { content_name: 'Logo da imobiliária', content_category: 'header_navigation' })} className={`${styles.navLogoLink} ${site?.id == 2080 ? styles.navLogoLinkCenter2080 : ''}`}>
                    <div className={`${styles.navLogoContainer} ${site?.id == 2570 ? styles.navLogoContainer2570 : ''}`}>
                        {site?.url_logo ? (
                            <Image
                                src={`${site?.url_logo}?v=${site?.contador_marca || 0}`}
                                alt={`Imobiliária ${site?.Dados?.empresa}`}
                                title={`Imobiliária ${site?.Dados?.empresa}`}
                                width={250}
                                height={logoHeight > 1 ? logoHeight : 60}
                                style={logoHeight > 1 ? {
                                    width: '100%', 
                                    maxHeight: logoHeight,
                                    height: '100%', 
                                    objectFit: 'contain' 
                                } :  {
                                    width: '100%', 
                                    height: '100%',
                                    objectFit: 'contain'
                                }}
                                priority
                                fetchPriority="high"
                                unoptimized
                            />
                        ) : (
                            <div className={styles.logo_empty} />
                        )}
                    </div>
                </Link>
                )}

                <div className={styles.juntos}>
                {menusElegiveis.map((v, idx) => (
                    <Link
                        prefetch={false}
                        href={withCodsite(v?.link ? v?.link : `/menu/${encodeURIComponent(v?.titulo)}`)}
                        key={v?.titulo ?? idx}
                        className={styles.menus}
                        passHref
                        aria-label={`Botão para navegar ao menu ${v?.titulo}`}
                        title={`Clique aqui para navegar ao menu ${v?.titulo}`}
                    >
                        <div className={styles.info_body} style={{ color: getFontColor() }}>
                            {v?.titulo}
                        </div>
                    </Link>
                    ))}
                {/* Desktop Search - Hidden on mobile */}
                {/* cs2619: 31/08 saiu a busca por código; 01/09 o cliente pediu também SEM o
                    botão BUSCA AVANÇADA — o bloco inteiro deixa de existir NO TOPO. A busca
                    avançada continua no hero da home (link "Busca avançada").
                    cs2504 (11/09): mesmo pedido — sem a busca no topo fixo; a busca por código
                    segue no hero da home (busca:4, "Já sabe o código?"). */}
                {TOPO_SEM_BUSCA_CODSITES.has(Number(site?.id)) ? null : (
                <div className={site?.id == 2379 ? styles.navDesktopSearch1 : styles.navDesktopSearch}>
                    <div className={styles.navSearchContainer}>
                        <input
                            className={styles.navSearchInput}
                            type="search"
                            id="myplace"
                            style={site?.id == 2379 ? {minWidth: 200,width: "100%",border: `1px solid ${cor_font_2}`,color: cor_font_2} : {border: `1px solid ${cor_font_2}`,color: cor_font_2}}
                            placeholder={site?.id == 2379 ? "BUSCA POR NOME OU CÓDIGO" : "BUSCA POR CÓDIGO"}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                        />
                        <style>
                            {`
                            #myplace::placeholder {
                                color: ${getFontColor()};
                            }
                            `}
                        </style>
                        <button 
                            className={styles.navSearchButton}
                            style={{background: site?.cor2,color: cor_font_2,border: `1px solid ${cor_font_2}`}}
                            onClick={handleSearch}
                        >
                            OK
                        </button>
                    </div>
                    <button
                        className={styles.navAdvancedButton}
                        style={{background: site?.cor2,color: cor_font_2}}
                        onClick={handleAdvancedSearch}
                    >
                        BUSCA AVANÇADA
                    </button>
                </div>
                )}
                </div>
                 {/* Menu Button - Desktop */}
                <div style={{display: "flex", alignItems: "center"}}>
                    {/* cs2504 (05/10): idioma (GTranslate) e moeda dos preços — gates em utils/idiomaMoedaSite.
                        21/10: o seletor de idiomas vale para qualquer tenant com a opção do CRM ligada (aqui no
                        cabeçalho; nos outros topos é o botão flutuante do _app). O select manual de moeda
                        continua só no 2504. No celular a dupla desce para uma faixa logo abaixo do topo. */}
                    {(temSeletorIdiomas(site) || temSeletorMoedaManual(site)) && (
                        <div className={styles.seletores} style={{ '--fundo-seletores': getBackgroundColor() } as React.CSSProperties}>
                            {temSeletorIdiomas(site) && <SeletorIdiomas wrapper="topo" />}
                            {temSeletorMoedaManual(site) && <SeletorMoeda />}
                        </div>
                    )}
                    {site?.redes_topo &&
                    <div className={`${styles.redes_sociais} ${site?.id == 1630 ? styles.redes_sociais_1630 : ''} ${shouldHideSite1630Socials ? styles.hide_non_home_1630 : ''}`}>
                        <div className={styles.container1} style={{display: 'flex'}}>
                            {site?.id == "2321" &&
                                <a
                                    rel="noopener noreferrer"
                                    href="mailto:contato@fcaimoveis.com.br"
                                    target='_blank'
                                    title={`Navegar para o email da imobiliária`}
                                    className={styles.adjust_img1}
                                >
                                    <Image
                                        alt={`Imagem Email`}
                                        src={IconEmail}
                                        height={30}
                                        width={30}
                                    />
                                </a>
                            }
                            {allSocials?.map((v) => {
                                if (v) {
                                    if (v.href) {
                                        return (
                                            <a
                                                aria-label={v.href}
                                                rel="noopener noreferrer"
                                                key={v.id}
                                                href={v.href}
                                                title={`Navegar para o ${v.rede} da imobiliária`}
                                                onClick={async (e) => {
                                                    e.preventDefault(); // Evita o redirecionamento automático

                                                    trackLeadLazy(); // Registra o evento Lead

                                                    trackMetaEvent(site, 'Contact', { content_name: 'Contato do cabeçalho', contact_method: 'whatsapp', content_category: 'header' });

                                                    // Garante que o evento seja enviado antes de abrir o WhatsApp
                                                    setTimeout(() => {
                                                    window.open(
                                                        v.href,
                                                        "_blank"
                                                    );
                                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                                }}
                                                className={styles.adjust_img1}
                                            >
                                                {v.icon}
                                            </a>
                                        );
                                    }
                                    return null;
                                }
                                return null;
                            })}
                        </div>
                    </div>
                    }
                    
                    <div className={styles.navMenuButton} onClick={openDrawer} style={site?.id == 2379 ? {gap: 8} : {}}>
                        <div className={styles.navMenuButtonLine} style={site?.id == 2379 ? {height: 1,width: 50,backgroundColor: getFontColor()} : {backgroundColor: getFontColor()}}></div>
                        <div className={styles.navMenuButtonLine} style={site?.id == 2379 ? {height: 1,width: 50,backgroundColor: getFontColor()} : {backgroundColor: getFontColor()}}></div>
                        <div className={styles.navMenuButtonLine} style={site?.id == 2379 ? {height: 1,width: 50,backgroundColor: getFontColor()} : {backgroundColor: getFontColor()}}></div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Topo2;
